import MyNavbar from "./components/MyNavbar2";
import { CurrentPlaylistContext, FAVOURITES_PLAYLIST_ID, TOP_SONGS_PLAYLIST_ID } from "./contexts/CurrentPlaylistContext"; // Import the CurrentPlaylistContext
import { FavouritesContext } from "./contexts/FavouritesContext";
import { PlayerContext } from "./contexts/PlayerContext"; // Import the PlayerContext

import CatalogCard from "./components/CatalogCard";
import TopSongs from "./components/TopSongs";
import Player from "./components/Player";
import MiniPlayer from "./components/MiniPlayer";
import MeditationMode from "./components/MeditationMode";
import SqlGenerator from "./components/SqlGenerator";
import ModalCatalog from "./components/ModalCatalog";

import React, { useState, useEffect, useContext } from "react";
import { AmbientSoundContext } from "./contexts/AmbientSoundContext";
import LoadingCard from "./components/LoadingCard";
import SearchComponent from "./components/SearchComponent";
import Footer from "./components/Footer";
import Terms from "./components/Terms";
import { AnimatePresence } from "framer-motion";

const App = () => {
  //get current playlist context
  const {
    currentPlaylist,
    setCurrentPlaylist,
    setVideosDirectly,
    // eslint-disable-next-line no-unused-vars
    currentVideoIndex,
    setCurrentVideoIndex,
    isLoadingDB,
    isErrorLoadingDB,
    activePlaylist,
    activeVideoIndex,
    startPlaying,
  } = useContext(CurrentPlaylistContext);

  const { favourites } = useContext(FavouritesContext);

  const { showFullPlayer, setShowFullPlayer } = useContext(PlayerContext);
  const { stopSound } = useContext(AmbientSoundContext);

  // Sync favourites changes to browsing state
  useEffect(() => {
    if (currentPlaylist === FAVOURITES_PLAYLIST_ID) {
      setVideosDirectly(favourites);

      if (favourites.length > 0) {
        setCurrentVideoIndex((prev) => {
          if (prev >= favourites.length) return Math.max(0, favourites.length - 1);
          return prev;
        });
      } else if (favourites.length === 0) {
        setCurrentPlaylist(null);
      }
    }
  }, [favourites, currentPlaylist, setVideosDirectly, setCurrentVideoIndex, setCurrentPlaylist]);

  // Sync favourites changes to active (playing) state — only when favourites list itself changes
  useEffect(() => {
    if (activePlaylist === FAVOURITES_PLAYLIST_ID) {
      if (favourites.length === 0) {
        startPlaying(null, 0, []);
      } else {
        // Update active videos but keep current index
        startPlaying(FAVOURITES_PLAYLIST_ID, activeVideoIndex >= favourites.length ? 0 : activeVideoIndex, favourites);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favourites]);

  // Check if ?sql is in URL
  const showSqlGenerator = window.location.search.includes("sql");

  useEffect(() => {
    if (currentPlaylist != null && currentPlaylist !== TOP_SONGS_PLAYLIST_ID) {
      setShowCatalog(false);
      setShowFullPlayer(true);
    }
  }, [currentPlaylist, setShowFullPlayer]);

  const [showModal, setShowModal] = useState(false);
  const [showCatalog, setShowCatalog] = useState(true);
  const [showMeditationMode, setShowMeditationMode] = useState(false);
  const [showTopSongs, setShowTopSongs] = useState(false);

  // Show mini player when something is actively playing and either:
  // - not showing full player, OR
  // - full player is showing a different artist than what's playing
  const isBrowsingDifferentArtist = showFullPlayer && activePlaylist !== null && currentPlaylist !== activePlaylist;
  const showMiniPlayer = activePlaylist !== null && (!showFullPlayer || isBrowsingDifferentArtist) && !showMeditationMode;

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  const onPlaylistSelected = () => {
    setShowCatalog(false);
    setShowFullPlayer(true);
  };

  const onExpandMiniPlayer = () => {
    setShowCatalog(false);
    setShowFullPlayer(true);
  };

  const onHomeClick = () => {
    // Show catalog but keep the music playing (mini player will appear)
    setShowCatalog(true);
    setShowFullPlayer(false);
    // Don't reset the playlist - keep the music playing!
  };



  const openTopSongs = () => {
    setShowTopSongs(true);
    setShowCatalog(true);
    setShowFullPlayer(false);
    setShowMeditationMode(false);
  };

  const openFavourites = () => {
    if (favourites.length === 0) return;
    setCurrentPlaylist(FAVOURITES_PLAYLIST_ID);
    setVideosDirectly(favourites);
    setCurrentVideoIndex(0);
    setShowCatalog(false);
    setShowFullPlayer(true);
  };

  const toggleMeditationMode = () => {
    setShowMeditationMode(!showMeditationMode);
    if (!showMeditationMode) {
      // When entering meditation mode, hide catalog
      setShowCatalog(false);
      setShowFullPlayer(false);
    } else {
      // When leaving meditation mode, show catalog and stop ambient sounds
      setShowCatalog(true);
      setShowFullPlayer(false);
      stopSound();
    }
  };

  useEffect(() => {
    console.log("❤️ Jana");
  }, []);

  if ("serviceWorker" in navigator && "beforeinstallprompt" in window) {
    // Register the service worker
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log(
          "Service Worker registered with scope:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });

    // Add an event listener to detect the beforeinstallprompt event
    window.addEventListener("beforeinstallprompt", (event) => {
      // Prevent the default behavior to prevent automatic prompt
      event.preventDefault();

      // Save the event for later use
      let deferredPrompt = event;

      // Show your own custom install button or notification
      // Example: display an "Add to Home Screen" button
      const installButton = document.getElementById("install-button");
      console.log(installButton);
      if (installButton) {
        installButton.style.display = "block";

        // Add a click event listener to trigger the install prompt
        installButton.addEventListener("click", () => {
          // Trigger the deferredPrompt to show the install prompt
          console.log("👍", "butInstall-clicked");
          deferredPrompt.prompt();

          // Wait for the user to respond to the prompt
          deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === "accepted") {
              console.log("User accepted the install prompt");
            } else {
              console.log("User dismissed the install prompt");
            }

            // Reset the deferredPrompt variable
            deferredPrompt = null;
          });
        });
      }
    });
  }

  // Show SQL Generator page if ?sql in URL
  if (showSqlGenerator) {
    return <SqlGenerator />;
  }

  return (
    <div className="App">
      <MyNavbar
        onHome={onHomeClick}
        onShowCatalog={handleShowModal}
        isCatalogVisible={showCatalog}
        onToggleMeditation={toggleMeditationMode}
        isMeditationMode={showMeditationMode}
      />

      <div className={`container-main ${showMiniPlayer ? "with-mini-player" : ""}`}>
        <SearchComponent onSongSelected={onPlaylistSelected} />
        {/* {!showCatalog && (
          <Button className="btn-moje" onClick={handleShowModal}>
            Katalog interpretů
          </Button>
        )} */}

        <ModalCatalog show={showModal} handleClose={handleCloseModal}>
          <CatalogCard />
        </ModalCatalog>
        {isLoadingDB ? <LoadingCard isError={isErrorLoadingDB} /> : ""}

        {!isLoadingDB && showCatalog && (
          <div className="container-catalog">
            {showTopSongs ? (
              <TopSongs onBack={() => setShowTopSongs(false)} />
            ) : (
              <CatalogCard handleClose={onPlaylistSelected} />
            )}
          </div>
        )}

        {/*  <Button id="install-button" className="btn-moje">
          Instalovat
        </Button> */}

        {/* Single Player instance - always mounted when playlist selected or actively playing */}
        {(currentPlaylist !== null || activePlaylist !== null) && !isLoadingDB && (
          <div className={showFullPlayer ? "player-visible" : "player-hidden"}>
            <Player />
          </div>
        )}

        <Terms />
      </div>

      {/* Mini Player - fixed at bottom when browsing catalog with music playing */}
      <AnimatePresence>
        {showMiniPlayer && !isLoadingDB && (
          <MiniPlayer onExpand={onExpandMiniPlayer} />
        )}
      </AnimatePresence>

      {/* Meditation Mode - full screen with Bible quotes */}
      {showMeditationMode && !isLoadingDB && (
        <MeditationMode />
      )}

      <Footer
        onToggleMeditation={toggleMeditationMode}
        isMeditationMode={showMeditationMode}
        onOpenFavourites={openFavourites}
        onOpenTopSongs={openTopSongs}
      />
    </div>
  );
};

export default App;
